import React from "react";
import { ErrorMessage } from "formik";

const ErrorM: React.FC<{ name: string; classWrapper?: string }> = props => (
  <ErrorMessage name={props.name} className={props.classWrapper}>
    {msg => (
      <div className="ErrorMessage">
        {" "}
        {/* {console.log(props.classWrapper)} */}
        {msg}
      </div>
    )}
  </ErrorMessage>
);

export { ErrorM };
